define("shared/components/shared/post/secondary/saved-captions/wrapper", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{concat-classes "o--modalCard--secondary" (if this.isEditing "qa--createSavedCaptionsModal")}}>
    {{#if this.isEditing}}
      <Shared::Post::Secondary::SavedCaptions::Editor
        @exitEditingCaption={{perform @exitEditingCaption}}
        @location={{@location}}
        @savedCaptionToEdit={{@savedCaptionToEdit}}
        @setCaptionToEdit={{@setCaptionToEdit}}
      />
    {{else}}
      <div class="o--modalHeader u--row u--row--noCollapse">
        <p class="o--modalHeader__title u--col__11 qa--savedCaptions_title">
          {{t "posts.template.title"}}
        </p>
        <div class="u--col__1">
          <a class="u--float--right qa--savedCaptions_createBtn" {{on "click" (fn this.createNewSavedCaption "")}}>
            <span>
              {{svg-jar "add" class="o--icon--md o--icon--hl"}}
              <EmberTooltip @delay={{330}} @side="left">
                {{t "posts.template.tooltip"}}
              </EmberTooltip>
            </span>
          </a>
        </div>
      </div>
  
      <Shared::Post::Secondary::SavedCaptions::List
        @createNewSavedCaption={{this.createNewSavedCaption}}
        @location={{@location}}
        @mediaItem={{@mediaItem}}
        @post={{@post}}
        @postElementId={{@postElementId}}
        @setCaptionToEdit={{@setCaptionToEdit}}
        @socialProfile={{@socialProfile}}
      />
  
      <div class="o--modalFooter">
        <Shared::Ui::Button
          @additional="block"
          @onClick={{@toggle}}
          @text={{t "shared_words.done"}}
          @variant="outline"
          class="qa--savedCaptions_done_btn"
        />
      </div>
    {{/if}}
  </div>
  */
  {
    "id": "4V+stawt",
    "block": "[[[10,0],[15,0,[28,[37,0],[\"o--modalCard--secondary\",[52,[30,0,[\"isEditing\"]],\"qa--createSavedCaptionsModal\"]],null]],[12],[1,\"\\n\"],[41,[30,0,[\"isEditing\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@exitEditingCaption\",\"@location\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\"],[[28,[37,3],[[30,1]],null],[30,2],[30,3],[30,4]]],null],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"o--modalHeader u--row u--row--noCollapse\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"o--modalHeader__title u--col__11 qa--savedCaptions_title\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"posts.template.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--col__1\"],[12],[1,\"\\n        \"],[11,3],[24,0,\"u--float--right qa--savedCaptions_createBtn\"],[4,[38,5],[\"click\",[28,[37,6],[[30,0,[\"createNewSavedCaption\"]],\"\"],null]],null],[12],[1,\"\\n          \"],[10,1],[12],[1,\"\\n            \"],[1,[28,[35,7],[\"add\"],[[\"class\"],[\"o--icon--md o--icon--hl\"]]]],[1,\"\\n            \"],[8,[39,8],null,[[\"@delay\",\"@side\"],[330,\"left\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,4],[\"posts.template.tooltip\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,9],null,[[\"@createNewSavedCaption\",\"@location\",\"@mediaItem\",\"@post\",\"@postElementId\",\"@setCaptionToEdit\",\"@socialProfile\"],[[30,0,[\"createNewSavedCaption\"]],[30,2],[30,5],[30,6],[30,7],[30,4],[30,8]]],null],[1,\"\\n\\n    \"],[10,0],[14,0,\"o--modalFooter\"],[12],[1,\"\\n      \"],[8,[39,10],[[24,0,\"qa--savedCaptions_done_btn\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,9],[28,[37,4],[\"shared_words.done\"],null],\"outline\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13]],[\"@exitEditingCaption\",\"@location\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@mediaItem\",\"@post\",\"@postElementId\",\"@socialProfile\",\"@toggle\"],false,[\"concat-classes\",\"if\",\"shared/post/secondary/saved-captions/editor\",\"perform\",\"t\",\"on\",\"fn\",\"svg-jar\",\"ember-tooltip\",\"shared/post/secondary/saved-captions/list\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/post/secondary/saved-captions/wrapper.hbs",
    "isStrictMode": false
  });
  let WrapperComponent = _exports.default = (_class = class WrapperComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "store", _descriptor2, this);
    }
    get isEditing() {
      return this.args.savedCaptionToEdit !== null && this.args.savedCaptionToEdit !== undefined;
    }
    createNewSavedCaption(newCaptionContent) {
      const {
        currentGroup,
        currentUserModel
      } = this.auth;
      const savedCaption = this.store.createRecord('savedCaption', {
        content: newCaptionContent,
        group: currentGroup,
        user: currentUserModel
      });
      this.args.setCaptionToEdit(savedCaption);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "createNewSavedCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "createNewSavedCaption"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WrapperComponent);
});